export const environment = {
    production: false,
    apiUrl: 'https://testing-api.iglesialasendaantigua.com'
};
